module.exports = __webpack_public_path__ + "img/swine-site3.237fd6d3.svg";